import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const customToastStyles = {
    fontSize: '1rem',
    backgroundColor: '#dadada', // Dark background
    color: '#282828', // Light text color
    // border: '2px solid #444', // Border
};


export const showSuccessNotification = (message, duration = 7000) => {
    toast.success(message, {
        autoClose: duration,
        closeOnClick: true,
        className: 'rtl ml-8', // Apply custom classes
        style: customToastStyles, // Apply RTL styling and platform-specific margin
        // closeButton: <CustomCloseButton />, // Use the custom close button component
    });
};

export const showWarningNotification = (message, duration = 7000) => {
    toast.warning(message, {
        autoClose: duration,
        className: 'rtl ml-8',
        style: customToastStyles, // Apply RTL styling and platform-specific margin
        // closeButton: <CustomCloseButton />, // Use the custom close button component
    });
};

export const showErrorNotification = (message, duration = 7000) => {
    toast.error(message, {
        autoClose: duration,
        className: 'rtl ml-8',
        style: customToastStyles, // Apply RTL styling and platform-specific margin
        // closeButton: <CustomCloseButton />, // Use the custom close button component
    });
};
